import { render, staticRenderFns } from "./HomepageRTP.vue?vue&type=template&id=453b71c0&scoped=true&"
import script from "./HomepageRTP.vue?vue&type=script&lang=js&"
export * from "./HomepageRTP.vue?vue&type=script&lang=js&"
import style0 from "./HomepageRTP.vue?vue&type=style&index=0&id=453b71c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453b71c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453b71c0')) {
      api.createRecord('453b71c0', component.options)
    } else {
      api.reload('453b71c0', component.options)
    }
    module.hot.accept("./HomepageRTP.vue?vue&type=template&id=453b71c0&scoped=true&", function () {
      api.rerender('453b71c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/HomepageRTP.vue"
export default component.exports